__turbopack_context__.v({
  "countdown-spinner": "countdown-spinner-module-scss-module__ItcavW__countdown-spinner",
  "countdown-spinner-container": "countdown-spinner-module-scss-module__ItcavW__countdown-spinner-container",
  "countdown-spinner__circle": "countdown-spinner-module-scss-module__ItcavW__countdown-spinner__circle",
  "countdown-spinner__count": "countdown-spinner-module-scss-module__ItcavW__countdown-spinner__count",
});
